import { useState } from 'react'
import { calcPositions } from './galleryMosaicPositions'
import { Lightbox } from './Lightbox'

const COLS = 3
const ROWS = 3

/**
 * Pure display component for gallery-mosaic blocks.
 * No editing UI. Safe to copy to frontend.
 */
export function GalleryMosaicView({ data, emptyColor, onOpenLightbox }) {
  const [lightboxIndex, setLightboxIndex] = useState(null)
  const items = data?.items ?? []
  if (items.length === 0) return null
  const positioned = calcPositions(items)
  const lightboxImages = positioned.filter(item => item.url).map(item => item.fullUrl || item.url)

  return (
    <>
      <div className="w-full grid gap-1" style={{ gridTemplateColumns: `repeat(${COLS}, 1fr)`, gridTemplateRows: `repeat(${ROWS}, 1fr)`, aspectRatio: `${COLS} / ${ROWS}` }}>
        {positioned.map(item => {
          const colSpan = Math.min(item.colSpan ?? 1, COLS)
          const rowSpan = Math.min(item.rowSpan ?? 1, ROWS)
          return (
            <div key={item.id} className="overflow-hidden rounded-[4px]"
              style={{
                gridColumn: item.x != null ? `${item.x + 1} / span ${colSpan}` : `span ${colSpan}`,
                gridRow: item.y != null ? `${item.y + 1} / span ${rowSpan}` : `span ${rowSpan}`,
                background: item.url ? undefined : (emptyColor ?? 'rgba(249, 248, 246, 0.4)'),
              }}>
              {item.url && (
                <img
                  src={item.url}
                  alt=""
                  className="w-full h-full object-cover cursor-zoom-in"
                  loading="lazy"
                  onClick={() => onOpenLightbox ? onOpenLightbox(item.fullUrl || item.url) : setLightboxIndex(lightboxImages.indexOf(item.fullUrl || item.url))}
                />
              )}
            </div>
          )
        })}
      </div>
      {!onOpenLightbox && lightboxIndex !== null && (
        <Lightbox
          images={lightboxImages}
          index={lightboxIndex}
          onIndexChange={setLightboxIndex}
          onClose={() => setLightboxIndex(null)}
        />
      )}
    </>
  )
}
